import {
  StoryblokServerComponent,
  storyblokEditable,
} from "@storyblok/react/rsc";
import type { Timeline } from "@/types/storyblok";
import TimelineConnectors from "./Connectors";

// biome-ignore lint/suspicious/noRedeclare: Timeline is used for type safety
export default function Timeline({ blok }: { blok: Timeline }) {
  return (
    <div
      className="max-w-screen-2xl mx-auto p-4 sm:p-6 my-16"
      // biome-ignore lint/suspicious/noExplicitAny: Required for Storyblok React compatibility
      {...storyblokEditable(blok as any)}
    >
      {(blok.subtitle || blok.title) && (
        <div className="flex flex-col md:flex-row md:justify-between md:items-center">
          <div className="flex flex-col space-y-4 max-w-screen-lg">
            {blok.subtitle && (
              <span className="text-teal-500 text-2xl drop-shadow-2xl font-medium font-display uppercase">
                {blok.subtitle}
              </span>
            )}
            {blok.title && (
              <h2 className="text-5xl md:text-6xl drop-shadow-2xl font-extrabold font-display bg-gradient-to-br from-violet-100 via-zinc-50 to-violet-200 bg-clip-text text-transparent leading-tight pb-1">
                {blok.title}
              </h2>
            )}
            {blok.lead && (
              <p className="text-xl drop-shadow-2xl max-w-prose font-medium text-muted-foreground mt-4 sm:mt-6 mb-8">
                {blok.lead}
              </p>
            )}
          </div>
        </div>
      )}
      {blok.steps && blok.steps.length > 0 && (
        <div id={`timeline-${blok._uid}`} className="relative mt-8">
          <TimelineConnectors containerId={`timeline-${blok._uid}`} />
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-16 items-center">
            {/* biome-ignore lint/suspicious/noExplicitAny: Storyblok data is dynamic */}
            {blok.steps.map((nestedBlok: any, index: number) => (
              <div
                key={nestedBlok._uid}
                className="relative isolate overflow-visible z-10"
                data-timeline-node
              >
                <StoryblokServerComponent
                  // biome-ignore lint/suspicious/noExplicitAny: Required for Storyblok React compatibility
                  blok={nestedBlok as any}
                  index={index}
                />
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
